export const adminRoutePath = {
    auth: '/auth',
    admin: '/admin',
    gameManage: '/game-manage',
    dashboard: '/dashboard',
    order: '/order'
}